require('./_dealer-license.scss');

(function ($) {
  $(function () {
    window.dealerLicenceRetry = 1;
    let dealerLicence = document.querySelector("[dealer-license-url]");
    if (dealerLicence) {
      loadDealerLicence(dealerLicence);
    }

    function loadDealerLicence(element) {
      let url = element.getAttribute("dealer-license-url");
      fetch(url)
        .then(res => {
          if (!res.ok) {
            throw Error(res);
          }
          return res.text();
        })
        .then(result => {
          element.innerHTML = result;
        })
        .catch(error => {
          // retry
          if (window.dealerLicenceRetry > 0) {
            window.dealerLicenceRetry--;
            loadDealerLicence(element);
          }
        });
    }
  })
})(jQuery);